export default msg => {
  return `
    <html lang="pt-BR">
      <head>
        <meta charset="utf-8" />
        <title>Carregando...</title>
        <style>
          body {
            font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            height: 100vh;
            margin: 0;
          }
          .loader {
            width: 50px;
            --b: 8px;
            aspect-ratio: 1;
            border-radius: 50%;
            background: #1a284d;
            -webkit-mask:
              repeating-conic-gradient(#0000 0deg,#000 1deg 70deg,#0000 71deg 90deg),
              radial-gradient(farthest-side,#0000 calc(100% - var(--b) - 1px),#000 calc(100% - var(--b)));
            -webkit-mask-composite: destination-in;
                    mask-composite: intersect;
            animation: l5 1s infinite;
          }
          @keyframes l5 {to{transform: rotate(.5turn)}}
        </style>
      </head>
      <body>
        <div style="font-size: 1.15em">${msg}</div>
        <br>
        <div class="loader"></div>
      </body>
    </html>
  `;
};
